import React from "react";
import "./Loader.css";

const LoaderPage = () => {
  return (
    <div className="loader-container">
      <div className="loader" />
    </div>
  );
};

export default LoaderPage;
